import { AxiosPromise } from 'axios';
import qs from 'qs';
import { BaseService } from '../../../core/services/BaseServices';
import appStore from '../../../core/stores/AppStore';
import { BasicUser } from '../types/BasicUser';

export type TypeBasicList = 'OPERATOR_GROUP' | 'ACCOUNT_GROUP' | 'ACCOUNT_DISTRICT';

export interface ParamsProps {
  commodityIds?: number[];
  terminalIds?: number[];
  terminalId?: number;
}

export class BasicListByTypeService extends BaseService {
  constructor() {
    super('maintenance/basicListByType');
  }

  getTerminalDrivers = (id: string | number): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`DRIVER?paramColumnName=TERMINAL%5FID&isActiveOnly=true&paramColumnValue=${id}`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getLoadScheduleTerminalDrivers = (params: any = {}): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`DRIVER`, {
        params: { ...params, ...{ isActiveOnly: true } },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getRateSheetTypes = (): AxiosPromise<any> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?isActiveOnly=false&paramColumnValue=RATE_SHEET`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getTerminalTruks = (id: string | number): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`TRUCK?paramColumnName=TERMINAL%5FID&isActiveOnly=true&paramColumnValue=${id}`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getTerminalTrailers = (id: string | number): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`TRAILER?paramColumnName=TERMINAL%5FID&isActiveOnly=true&paramColumnValue=${id}`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  public getAllUsersActives(): AxiosPromise<any[]> {
    return this.httpAxios
      .get(`USER?isActiveOnly=false`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public getAllterminalsActive(): AxiosPromise<any[]> {
    return this.httpAxios
      .get(`TERMINAL?isActiveOn`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public getAllCodesActive(): AxiosPromise<any[]> {
    return this.httpAxios
      .get(`CODE_TYPE_SET?isActiveOnly=false&paramColumnValue=CONTACT%5FGROUP`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  getOperators = (ids: any[]): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`OPERATOR?isActiveOnly=false${getParameter(ids)}`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getAccounts = (params: any = {}): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`ACCOUNT`, {
        params: { ...params, ...{ isActiveOnly: false } },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getContracts = (params: any = {}): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CONTRACT`, {
        params: { ...params, ...{ isActiveOnly: false } },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getAccountsByTerminal = (params: any): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`ACCOUNT`, {
        params,
        paramsSerializer: param => {
          return qs.stringify(param, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getTerminals = (params: any = {}): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`TERMINAL`, {
        params: { ...params, ...{ isActiveOnly: false } },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getHazards = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?paramColumnValue=H2S%20HAZARD`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getDefaultProductTypes = (argParams: any = {}): AxiosPromise<any[]> => {
    const params = { paramColumnValue: 'PRODUCT_TYPE', ...(argParams || {}) };
    return this.httpAxios
      .get(`CODE_TYPE_SET`, {
        params: { isActiveOnly: false, ...(params || {}) },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getMarketersBuyers = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?paramColumnValue=MARKETER%20BUYER`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getDropOffTypes = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?isActiveOnly=false&paramColumnValue=DROP%20OFF%20TYPE`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getRegions = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?paramColumnValue=REGION`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getPickUpsOrDropOffsByAccount = (
    id: number | string,
    type: 'PICK_UP' | 'DROP_OFF',
    commodities?: any[],
    params?: any
  ): AxiosPromise<any[]> => {
    const queryTerminal = params?.terminalId ? `&terminalId=${params.terminalId}` : '';
    const queryOperator = params?.operatorId ? `&operatorId=${params.operatorId}` : '';
    const queryIsActiveOnly = params?.isActiveOnly ? `&isActiveOnly=${params.isActiveOnly}` : '&isActiveOnly=false';
    const nameSearch = !!params?.nameSearch ? `&nameSearch=${encodeURIComponent(params.nameSearch)}` : '';
    return this.httpAxios
      .get(
        `${type}?paramColumnValue=${id}${queryTerminal}${queryOperator}${queryIsActiveOnly}${
          commodities ? getParameter(commodities) : ''
        }${nameSearch}`,
        params
      )
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getContractors = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CONTRACTOR?isActiveOnly=false`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getAllOperators = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`OPERATOR?isActiveOnly=false`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getTrailersCapacity = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?paramColumnValue=TRAILER%20CAPACITY&isActiveOnly=false`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getMeters = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?paramColumnValue=METER&isActiveOnly=false`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };
  getDrivers = (params: any = {}): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`DRIVER`, {
        params: { ...params, ...{ isActiveOnly: false } },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getTrailers = (params: any = {}): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`TRAILER`, {
        params: { isActiveOnly: false, ...(params || {}) },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getTrucks = (params: any = {}): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`TRUCK`, {
        params: { isActiveOnly: false, ...(params || {}) },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getPickUps = (ids?: number[]): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`PICK_UP?isActiveOnly=false${(ids && getParameter(ids)) || ''}`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getDropOffs = (params: ParamsProps): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`DROP_OFF`, {
        params: { ...(params || {}), ...{ isActiveOnly: false } },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getDropOffsByTerminal = (id: number): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`DROP_OFF?isActiveOnly=false&terminalId=${id}&commodityIds=${appStore.selectedCommodity}`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getDropOffsByTerminalAndLoadId = (id: number, loadCommodityId?: number): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(
        `DROP_OFF?isActiveOnly=false&terminalId=${id}&commodityIds=${loadCommodityId || appStore.selectedCommodity}`,
        {}
      )
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getUserGroups = (ids?: number[]): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`USER_GROUP?isActiveOnly=false${(ids && getParameter(ids)) || ''}`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  public getAllBasicListByType(type: TypeBasicList): AxiosPromise<any[]> {
    return this.httpAxios
      .get(`${type}?isActiveOnly=false`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  getCodeTypeSetByType = (params: any): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET`, { params })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getCodeByType = (params: any): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`code`, { params, baseURL: `${process.env.REACT_APP_API_URL}maintenance/` })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getDriverGroups = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?paramColumnValue=DRIVER_GROUP&isActiveOnly=false`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getAccountGroups = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?paramColumnValue=ACCOUNT_GROUP&isActiveOnly=false`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getOperatorGroups = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?paramColumnValue=OPERATOR_GROUP&isActiveOnly=false`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getCdlClass = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`CODE_TYPE_SET?paramColumnValue=CDL%20CLASS&isActiveOnly=false`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getCountryPhoneCodes = (): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`countryPhoneCodes`, { baseURL: `${process.env.REACT_APP_API_URL}maintenance/` })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getUserBasic = ({ orgID, groupName }: BasicUser): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`/userBasicList/${orgID}`, {
        params: groupName,
        paramsSerializer: params => {
          return qs.stringify({ groupName: params }, { arrayFormat: 'repeat' });
        },
        baseURL: `${process.env.REACT_APP_API_URL}user`
      })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  getAvailableLoadRequirements = (params: any): AxiosPromise<any[]> => {
    return this.httpAxios
      .get(`util/availablerequirements`, { params, baseURL: `${process.env.REACT_APP_API_URL}` })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };
}

const basicListByTypeService = new BasicListByTypeService();

export default basicListByTypeService;

const getParameter = (ids: any[]): string => {
  let parameters = '';
  ids.forEach(id => {
    parameters += `&commodityIds=${id}`;
  });
  return parameters;
};
